export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I was terrified of Internal Affairs reviewing my use-of-force reports. Everything felt like a legal trap. After 3 days with the SIGMA SMART™ prompts, I structured my first bulletproof narrative. Now, I finish my shift on time every single day.',
    name: 'Officer Mark T.',
    location: 'Chicago, IL · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3b0c83aa-dbc2-4f4d-8652-cc139f27d6c0.jpg',
  },
  {
    quote:
      'I was drowning in case files, frustrated because paperwork was keeping me away from the street. This system actually works. The legal precision in the Crime Scene pack is unmatched. My reports are now the gold standard in my unit.',
    name: 'Detective Sophia L.',
    location: 'London, UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/0584dc22-8540-4131-aa60-b9065f6aeead.jpg',
  },
  {
    quote:
      "I was worried AI would sound too 'robotic' for a court statement. SIGMA SMART™ proved me wrong. The prompts are vetted and professional. I felt confident using them from DAY ONE.",
    name: 'Sergeant David P.',
    location: 'Toronto, Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b730c42c-2c40-4297-a406-78f2871df410.jpg',
  },
];
